import { Controller } from '@hotwired/stimulus'

const STATE_NONE = 'none'
const STATE_INCLUDED = 'included'
const STATE_EXCLUDED = 'excluded'

export default class extends Controller {
  static targets = ['plannedInput', 'unwantedInput']
  static values = { state: { type: String, default: STATE_NONE } }

  connect () {
    this.#render()
  }

  include () {
    this.#toggle(STATE_INCLUDED)
  }

  exclude () {
    this.#toggle(STATE_EXCLUDED)
  }

  #toggle (state) {
    this.stateValue = this.stateValue === state ? STATE_NONE : state
    this.#render()
    this.element.dispatchEvent(new Event('change', { bubbles: true }))
  }

  #render () {
    this.element.dataset.state = this.stateValue
    this.plannedInputTarget.disabled = this.stateValue !== STATE_INCLUDED
    this.unwantedInputTarget.disabled = this.stateValue !== STATE_EXCLUDED
  }
}
